export enum EStorageType {
    SESSION_STORAGE = 'sessionStorage',
    LOCAL_STORAGE = 'localStorage',
}

export enum ELocalStorageKeys {
    SESSION_DATA = 'sessionData',
    SESSION_TOKEN = 'sessionToken',
    PLAYER_DATA = 'playerData',
    CURRENT_LANGUAGE = 'currentLanguage',
    CURRENT_AVAILABILITY = 'currentAvailability',
    ANALYTICS_CONSENT = 'analyticsConsent',
    PUBLISHER_META = 'publisherMeta',
    CLIENT_GA_ID = 'ga_client_id',
    BACK_TO_STORE = 'backToStore',
    IS_FREE_ORDER_SELECTED = 'isFreeOrderSelected',
    INTEGRATION_PORFILE = 'integrationProfile',
    MOCK_ENV = 'ac_mock_env',
    OVERRIDE_STORE = 'override_store',
    SHOW_LOGIN_APPROVAL_MODAL = 'showLoginApprovalModal',
    DEEPLINK_APPROVED_SESSION_TOKEN = 'deeplinkApprovedSessionToken',
    MOCK_OFFERS_API = 'ac_mock_offers_api',
    MOCK_BOOT_API = 'ac_mock_boot_api',
    MOCK_TEMPLATE_API = 'ac_mock_template_api',
    DEV_API_MOCK_COOKIE = 'ac_dev_api_mock',
    CURRENT_STORE_ID = 'currentStoreId',
    PORTAL_ID = 'portalId',
    USER_LOGIN_TERMS_CONSENT = 'userLoginTermsConsent',
    LAST_VISITING_PAGE = 'lastVisitingPage',
    DAILY_BONUS_SHOW_NEXT_PRODUCT = 'dailyBonus_showNextProduct',
    AUTO_COLLECT_FLAG = 'autoCollectFlag',
    LANGUAGE_EXPLICITLY_SET = 'languageExplicitlySet',
    LOCAL_ADDRESS = 'localAddress',
}

export enum ESessionStorageKeys {
    SESSION_DATA = 'sessionData',
    SESSION_TOKEN = 'ac_sessionToken',
    FACEBOOK_ACCESS_TOKEN = 'facebookAccessToken',
    APPLE_REDIRECT = 'appleRedirect',
    PENDING_ORDER_ID = 'pendingOrderId',
    ORDER_PAYMENT_PROVIDER = 'orderPaymentProvider',
    ACTIVE_MISSIONS_LENGTH = 'activeMissionsLength',
    SOURCE = 'source',
    INSTALL_PROMPT_FIRED = 'installPromptFired',
    UTM_PARAMS = 'utmParams',
    PLAYER_DETAILS = 'ac_playerDetails',
    REDIRECT_STATE = 'redirectState',
    D10X_LINK_ID = 'd10x_link_id',
    D10X_ORG = 'd10x_org',
    TRACKED_PAGE = 'trackedPage',
}
